export let Microapp;
(function (Microapp) {
  Microapp["CampaignAssistant"] = "campaign-assistant";
  Microapp["EmailSignatureGenerator"] = "email-signature-generator";
  Microapp["BlogIdeasGenerator"] = "blog-ideas-generator";
  Microapp["LandingPageCreator"] = "landing-page-creator";
  Microapp["WebsiteGrader"] = "website-grader";
  Microapp["MarketingEmailCreator"] = "marketing-email-creator";
})(Microapp || (Microapp = {}));